import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigInstanceToken,
    ConfigInterface,
    NotificationInterface,
    OnlineOnlyService,
    SynchronizationInstanceToken,
    SynchronizationInterface,
    SyncQueueService,
    UriUtilitiesService,
    UserMasterInstanceToken,
    UserMasterInterface,
} from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable } from 'rxjs';
import { NotificationInstanceToken } from '../core/interfaces/notification.interface';
import { FormsWriteWithPaceOfflineService } from './forms-write-with-pace-offline.service';
import { FormsWriteInterface, ODataReleaseLockPayload, ODataSubmitFormPayload } from './forms-write.interface';
import { OdataFormsService } from './odata-forms.service';
import { XmlParserService } from './xml-parser.service';
import { XmlSerializerService } from './xml-serializer.service';

@Injectable({
    providedIn: 'root',
})
export class FormsWriteOnlineOnlyService extends FormsWriteWithPaceOfflineService implements FormsWriteInterface {
    public constructor(
        @Inject(LogInstanceToken) log: LogInterface,
        @Inject(ConfigInstanceToken) configService: ConfigInterface,
        @Inject(SynchronizationInstanceToken) synchronizationService: SynchronizationInterface,
        syncQueueService: SyncQueueService,
        @Inject(UserMasterInstanceToken) userMasterService: UserMasterInterface,
        @Inject(NotificationInstanceToken) notificationService: NotificationInterface,
        @Inject(ClientManagerInstanceToken) clientManager: ClientManagerInterface,
        xmlParserService: XmlParserService,
        xmlSerializerService: XmlSerializerService,
        uriUtilities: UriUtilitiesService,
        onlineOnlyService: OnlineOnlyService,
        httpClient: HttpClient,
        odataFormsService: OdataFormsService,
    ) {
        super(
            log,
            configService,
            synchronizationService,
            syncQueueService,
            userMasterService,
            notificationService,
            clientManager,
            xmlParserService,
            xmlSerializerService,
            uriUtilities,
            onlineOnlyService,
            httpClient,
            odataFormsService,
        );
    }

    protected postRequest(url: string, payload: ODataSubmitFormPayload | ODataReleaseLockPayload): Observable<unknown> {
        return this.onlineOnlyService.post(url, payload);
    }

    public getBasePath(): string {
        return ''; // base path is set in online-only.interceptor
    }
}
